import React, { useState, useEffect } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { FaUsers, FaUserPlus, FaRegCheckCircle } from "react-icons/fa";
import Header1 from "../../components/header1/Header1";
import { fetchStudentRegistrations, sendPasswordEmailToAllUsers } from "../../services/studentportalapis";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import * as XLSX from "xlsx"; //Import xLsx library
import Footer from "../../components/footer/Footer";
import { FaUserGraduate, FaJava } from "react-icons/fa";
import { SiPython } from "react-icons/si";




const Admin = () => {
  const [studentsData, setStudentsData] = useState({
    associateRegistrations: [],
    partnershipRegistrations: []
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // Initialize navigate function

  useEffect(() => {
    const fetchData = async () => {
      try {
        const totalRegistrations = await fetchStudentRegistrations();
        setStudentsData(totalRegistrations);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const downloadExcel = () => {
    
    if (combinedStudents.length === 0) {
      alert("No data available to download!");
      return;
    }
     // Filter out unnecessary fields
     const filteredData = combinedStudents.map(
      ({ collegeProfilePhoto, coordinators, ...rest }) => rest
    );


    // Create a worksheet
    const worksheet = XLSX.utils.json_to_sheet(filteredData);

    // Create a workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students Data");

    // Download the Excel file
    XLSX.writeFile(workbook, "StudentsData.xlsx");
  };

  const sendPassowrdToAllUsers = async () => {
      try {
        const data = await sendPasswordEmailToAllUsers();
        console.log("data: "+data);

      } catch (err) {
        throw err;
      }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error fetching data: {error.message}</p>;
  }


  const collegeRegistrations = studentsData.partnershipRegistrations?.length || 0;
  const associateRegistrations = studentsData.associateRegistrations?.length || 0;
  const totalRegistrations = collegeRegistrations + associateRegistrations;

  const combinedStudents = [
    ...(studentsData.partnershipRegistrations || []),
    ...(studentsData.associateRegistrations || [])
  ];

  const javaTrackCount = combinedStudents.filter(student => student.trackName === "Java").length;
  const pythonTrackCount = combinedStudents.filter(student => student.trackName === "Python").length;
  const totalTrackCount = javaTrackCount + pythonTrackCount;

  const javaStudents = combinedStudents.filter(student => student.trackName === "Java");
  const pythonStudents = combinedStudents.filter(student => student.trackName === "Python");

  // Helper to calculate average
  const getAverageCompletion = (students) => {
    if (students.length === 0) return 0;
    const total = students.reduce((sum, student) => sum + (student.completionPercentage || 0), 0);
    return (total / students.length).toFixed(1); // One decimal point
  };

  const avgJavaCompletion = getAverageCompletion(javaStudents);
  const avgPythonCompletion = getAverageCompletion(pythonStudents);


  return (
    <div className="admin">
      <Header1 />
      <div className="min-h-screen bg-gray-100 p-6">
        {/*Stat Card*/}
        <section className="flex flex-wrap justify-around my-5 space-x-2">
          <div className="bg-blue-300 p-4 w-full sm:w-1/4 flex flex-col items-start mb-4 rounded shadow-lg">
          <div className="flex justify-between w-full items-center mb-2">
            <p className="text-2xl">{totalRegistrations}</p>
            <FaUsers className="h-12 w-12 text-blue-600" />
          </div>
          <hr className="my-2 border-white-600 w-full" />
          <h3 className="mt-2 text-lg font-semibold mb-2">
            Student Registrations
          </h3>

          <div className="flex justify-between w-full gap-2">
            <div className="bg-white text-black flex-1 p-3 rounded shadow-sm text-center">
              <FaUserPlus className="mx-auto text-green-600 text-2xl mb-1" />
              <p className="font-semibold text-sm">College</p>
              <p>{collegeRegistrations}</p>
            </div>

            <div className="bg-white text-black flex-1 p-3 rounded shadow-sm text-center">
              <FaUserPlus className="mx-auto text-purple-600 text-2xl mb-1" />
              <p className="font-semibold text-sm">Associate</p>
              <p>{associateRegistrations}</p>
            </div>
          </div>
        </div>


          <div className="bg-green-300 p-4 w-full sm:w-1/4 flex flex-col items-start mb-4 rounded shadow-lg">
            {/* Total Track Selection */}
            <div className="flex justify-between w-full items-center mb-2">
              <p className="text-2xl">{totalTrackCount}</p>
              <FaUserGraduate className="h-12 w-12 text-blue-600" />
            </div>
            <hr className="my-2 border-white-400 w-full" />
            <h3 className="mt-2 text-lg font-semibold mb-2">Track Selections</h3>

            {/* Side-by-Side Boxes */}
            <div className="flex justify-between w-full gap-2">
              {/* Java */}
              <div className="bg-white text-black flex-1 p-3 rounded shadow-sm text-center">
                <FaJava className="mx-auto text-orange-500 text-2xl mb-1" />
                <p className="font-semibold">Java</p>
                <p>{javaTrackCount}</p>
              </div>

              {/* Python */}
              <div className="bg-white text-black flex-1 p-3 rounded shadow-sm text-center">
                <SiPython className="mx-auto text-yellow-500 text-2xl mb-1" />
                <p className="font-semibold">Python</p>
                <p>{pythonTrackCount}</p>
              </div>
            </div>
          </div>



          <div className="bg-yellow-300 p-4 w-full sm:w-1/4 flex flex-col items-start mb-4 rounded shadow-lg">
            <div className="flex justify-between w-full items-center mb-2">
              <p className="text-2xl">{((+avgJavaCompletion + +avgPythonCompletion) / 2).toFixed(1)}%</p>
              <FaRegCheckCircle className="h-12 w-12 text-blue-600" />
            </div>
            <hr className="my-2 border-white-600 w-full" />
            <h3 className="mt-2 text-lg font-semibold mb-2">
              Avg Course Completion
            </h3>

            <div className="flex justify-between w-full gap-2">
              <div className="bg-white text-black flex-1 p-3 rounded shadow-sm text-center">
                <FaJava className="mx-auto text-orange-500 text-2xl mb-1" />
                <p className="font-semibold">Java</p>
                <p>{avgJavaCompletion}%</p>
              </div>

              <div className="bg-white text-black flex-1 p-3 rounded shadow-sm text-center">
                <SiPython className="mx-auto text-yellow-500 text-2xl mb-1" />
                <p className="font-semibold">Python</p>
                <p>{avgPythonCompletion}%</p>
              </div>
            </div>
          </div>

        </section>

        {/* Buttons for Redirection */}
        <div className="flex justify-between mb-5">
          <button
            onClick={() => navigate("/admin-approved-email-control")} // Redirect to Page1
            className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
          >
            Admin Approved Emails
          </button>
          <button
            onClick={() => navigate("/admin-course-control")} // Redirect to Page2
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded"
          >
            Admin Course Control
          </button>

          <button
            onClick={() => navigate("/addProject")} // Redirect to project control
            className="bg-yellow-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded"
          >
            Project Details
          </button>

          <button
            onClick={downloadExcel} // Download button
            className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-2 px-4 rounded"
          >
            Download Data
          </button>

          <button
             // Bulk Email button
            onClick={() => sendPassowrdToAllUsers()}
            className="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 rounded"
          >
           Send Bulk Email
          </button>
        </div>

        {/* Table without Search */}
        <section className="bg-white p-5 rounded-lg">
          <div className="overflow-x-auto">
            {combinedStudents.length > 0 ? (
              <table className="min-w-full bg-gray-50 rounded-lg">
                <thead>
                  <tr className="bg-blue-600 text-white">
                    <th className="py-3 px-4">Student Name</th>
                    <th className="py-3 px-4">Email</th>
                    <th className="py-3 px-4">Phone</th>
                    <th className="py-3 px-4">College</th>
                    <th className="py-3 px-4">Specialization</th>
                    <th className="py-3 px-4">
                      Planned Graduation Completion Year
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {combinedStudents.map((student, index) => (
                    <tr key={index} className="border-b hover:bg-gray-100">
                      <td className="py-3 px-4">{`${student.firstName} ${student.lastName}`}</td>
                      <td className="py-3 px-4">{student.email}</td>
                      <td className="py-3 px-4">{student.phone}</td>
                      <td className="py-3 px-4">{student.collegeName}</td>
                      <td className="py-3 px-4">{student.branchName}</td>
                      <td className="py-3 px-4">
                        {student.plannedPassOutYear}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="text-center">No students found</p>
            )}
          </div>
        </section>
      </div>
      <Footer/>
    </div>
  );
};

export default Admin;
